/* Pulse Footer — section behaviors: exclusive-mode accordions, locale
   picker toggle (with outside-click dismiss), and edge-to-edge wordmark
   auto-fit (text mode). ES5-compatible for Shopify theme compatibility. */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('.pulse-footer');
    for (var i = 0; i < sections.length; i++) {
      setup(sections[i]);
    }
  }

  function setup(section) {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    bindExclusiveAccordions(section);
    bindLocaleModal(section);
    fitWordmark(section);
    syncDesktopAccordions(section);
  }

  /* On desktop, every accordion in the top grid is forced open so its
     content shows as an unfurled column. CSS alone isn't reliable —
     some browsers hide <details> content via mechanisms that bypass
     CSS overrides — so we set the [open] attribute directly. The
     CSS for desktop also makes the summary inert (pointer-events:
     none) so users can't toggle it. On mobile we strip [open] so
     accordions return to their click-to-expand behavior. */
  function syncDesktopAccordions(section) {
    var grid = section.querySelector('.pulse-footer__top-grid');
    if (!grid) return;
    var accordions = grid.querySelectorAll('.pulse-footer__accordion');
    if (!accordions.length || !window.matchMedia) return;

    var mq = window.matchMedia('(min-width: 750px)');

    function apply() {
      var isDesktop = mq.matches;
      for (var i = 0; i < accordions.length; i++) {
        if (isDesktop) {
          accordions[i].setAttribute('open', '');
        } else {
          accordions[i].removeAttribute('open');
        }
      }
    }

    apply();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      /* Older Safari fallback. */
      mq.addListener(apply);
    }
  }

  function fitWordmark(section) {
    var box = section.querySelector('[data-pulse-footer-wordmark]');
    if (!box) return;
    var text = box.querySelector('[data-pulse-footer-wordmark-text]');
    var img = box.querySelector('[data-pulse-footer-wordmark-img]');
    if (!text && !img) return;

    function clipPct() {
      var clipStr = box.style.getPropertyValue('--phf-wm-clip') || '12%';
      var pct = parseFloat(clipStr) / 100;
      return isNaN(pct) ? 0 : pct;
    }

    function fitText() {
      text.style.fontSize = '100px';
      var natural = text.scrollWidth;
      var available = box.clientWidth;
      if (natural === 0 || available === 0) return;
      var size = 100 * (available / natural);
      text.style.fontSize = size + 'px';
      box.style.height = (size * (1 - clipPct())) + 'px';
    }

    function fitImg() {
      var available = box.clientWidth;
      var ratio = img.naturalWidth / img.naturalHeight;
      if (!available || !ratio || !isFinite(ratio)) return;
      /* Image renders at width: 100%; height: auto, so its rendered
         height = available / ratio. We crop the bottom by clipPct
         of that rendered height. */
      var renderedHeight = available / ratio;
      box.style.height = (renderedHeight * (1 - clipPct())) + 'px';
    }

    var fit = text ? fitText : fitImg;

    fit();
    /* For image mode, the natural dimensions may not be known until
       the image finishes loading. Re-fit on load. */
    if (img && !img.complete) {
      img.addEventListener('load', fit);
    }
    /* Re-fit on resize. */
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(fit);
      ro.observe(box);
    } else {
      window.addEventListener('resize', fit);
    }
    /* Re-fit after webfonts load (text mode only — but cheap to run). */
    window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(fit);
    }
  }

  function bindExclusiveAccordions(section) {
    var group = section.querySelector('[data-pulse-footer-accordions]');
    if (!group) return;
    group.addEventListener('click', function (e) {
      var summary = e.target.closest ? e.target.closest('summary') : null;
      if (!summary) return;
      var opening = summary.parentElement;
      if (!opening || opening.tagName !== 'DETAILS') return;
      /* If currently open, the click will close it natively — no others to touch. */
      if (opening.open) return;
      /* About to open — close every other open <details> inside the group. */
      var others = group.querySelectorAll('details[open]');
      for (var i = 0; i < others.length; i++) {
        if (others[i] !== opening) {
          others[i].removeAttribute('open');
        }
      }
    });
  }

  function bindLocaleModal(section) {
    var trigger = section.querySelector('[data-pulse-footer-locale-open]');
    var modal = section.querySelector('[data-pulse-footer-locale-modal]');
    if (!trigger || !modal) return;

    function open() {
      trigger.setAttribute('aria-expanded', 'true');
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        /* Fallback for browsers without <dialog> support. Display as a
           plain block; the inner CSS still gives it the modal look. */
        modal.setAttribute('open', '');
      }
    }
    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    }

    trigger.addEventListener('click', open);

    /* Close button(s) inside the modal. */
    var closers = modal.querySelectorAll('[data-pulse-footer-locale-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', close);
    }

    /* Click on the backdrop (outside the inner card) closes the modal.
       The modal itself fills the viewport area; the inner card is
       smaller, so any click on the dialog whose target is the dialog
       itself is a backdrop click. */
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    /* Native <dialog> emits 'close' when ESC is pressed; sync state. */
    modal.addEventListener('close', function () {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-bind on section reload. */
  document.addEventListener('shopify:section:load', init);
})();
